module.exports = __webpack_public_path__ + "staticcomp/img/content_3.fc689ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/9/content_3.jpg
// module id = w2Qo
// module chunks = 39